<div class="wrapper has-padding">
  <h2 class="bofa--heading is-4">Forgot Password</h2>
  <p class="is-taller"><a [routerLink]="['/securityQuestions']" class="bofa--button primary large mobile-flex">Reset using security questions</a></p>
  <p class="is-taller"><a [routerLink]="['/forgotPasswordOTP']" class="bofa--button secondary outlined mobile-flex">Reset using OTP: you will receive an email</a></p>
  <p class="is-taller"><a [routerLink]="['/login']" class="bofa--button reverse mobile-flex ">&larr; Back</a></p>
</div>
